import { PropsWithChildren } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, typographyStyle, Colors } from '@revenuemarket/cds';
import { Typography } from 'antd';

interface Props extends PropsWithChildren {
  onClick: () => void;
}

const LabelCreateButton: React.FC<Props> = ({ onClick, children }) => {
  return (
    <Button
      icon={<PlusOutlined />}
      style={{
        width: 'fit-content',
      }}
      onClick={onClick}
    >
      <Typography.Text
        style={{
          ...typographyStyle['14_400'],
          color: Colors.gray700,
        }}
      >
        {children}
      </Typography.Text>
    </Button>
  );
};

export default LabelCreateButton;
